// extracted by mini-css-extract-plugin
module.exports = {"layout":"_3hZxWY3DBCFi-jgdTB1xOk","childrenWrap":"_1o4iWACSrqAoQO7HRDXoE7"};